import { AxiosResponse } from 'axios';
import httpService from '../../Services/httpService';

import { DestinationContent } from './Interfaces/DestinationMainNav';
// import { localJsonData } from './localJsonData';

import { LocalStorageCacheService } from 'mvw-component-library';
import { DESTINATION_NAV_API_URL, LOCALSTORAGE_DEST_NAV_KEY } from '../../Utility/constants';
// Accessing Jahia content for destination Main Nava data which will be replaced by Exp API later
export const getDestinationMainNavData = async (): Promise<DestinationContent> => {
  let response: any;
  let contentData: any;
  let returnValue: DestinationContent = {
    hasError: false,
  };
  try {
    let localStorageDestMainContent: any = LocalStorageCacheService.get(LOCALSTORAGE_DEST_NAV_KEY);
    if (localStorageDestMainContent) {
      contentData = JSON.parse(localStorageDestMainContent);
      returnValue.data = contentData;
      returnValue.hasError = false;
    } else {
      response = await httpService.getJahiaContent<AxiosResponse>(DESTINATION_NAV_API_URL);
      contentData = response;
      returnValue.data = contentData;
      returnValue.hasError = false;
      // contentData = response ? localJsonData : localJsonData;
      LocalStorageCacheService.set(LOCALSTORAGE_DEST_NAV_KEY, contentData, 5);
    }
  } catch (e: any) {
    // returnValue.data = contentData;
    returnValue.hasError = true;
  }
  return returnValue;
};
export const getAccessToken = () => {
  const rootElement = document.getElementById('userObject');
  const dataUser = rootElement?.getAttribute('data-user');
  const parsedUserData = dataUser && JSON.parse(dataUser);
  let accessToken = parsedUserData && parsedUserData.cognitoAccessToken;
  // accessToken = `eyJraWQiOiJUd01mcitiOU02UzltVlpYRjlqMENSWHFmaVwvVWtKRUd4WnVNVDZzdlA3az0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI0MTE2YzE3OC1lYWI2LTRlMzQtOWE5YS05MzYyNjMwMGU2MWIiLCJldmVudF9pZCI6ImVlZDkzM2I5LThlNjMtNGQyMi1iMTMzLTQyODMzNGM5ZDNhMCIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE2NTAzNjkzMzAsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy1lYXN0LTEuYW1hem9uYXdzLmNvbVwvdXMtZWFzdC0xX09WRmpVd0hYUCIsImV4cCI6MTY1MDM3MjkzMCwiaWF0IjoxNjUwMzY5MzMwLCJqdGkiOiJmZDU4NTJiMy1kMWVlLTQwZGQtOTc2My1mMmNiZGZiMzBiNmUiLCJjbGllbnRfaWQiOiI0b3I4ZHNlMGJtYXA3OXE4OXJlOW9uZDY0YyIsInVzZXJuYW1lIjoibXNoaWJhdGEifQ.OuCRoD5KtANnCEJ7NcLFj7BNhv-EeEBRn6zOkorLUHReFQYc5vCTyQ9dWNGR8otxNRU2lBkYn_WeWRwcTQd9TNRE8k1dxyLdbkhYMi2n6X7GesWB__aTwzuotgsf4XUVeYIVdITUWcIoTwCf8dVmzBuBHF9qQmv_7gvX7h9ssyhgYY-OQr540h3ejNXZbLxipJnix_sfz9v_kV2sjvWM8os8B0dikkr7JKO9SytOJ3Caxcj3xo9Boi-cGc1jiLe4HHyBnqohfV0tLWgYl1xRJH-w3cWOQyOAPNJMM_WtAMjxSNIvI5i-XEeA0tlrPtisMj2M9hzw11f0N2-KY2ZpPQ`;
  accessToken = accessToken?.length > 0 ? `Bearer ${accessToken}` : '';

  return accessToken;
};
